import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UnauthorizedResponseInterceptor } from './interceptors/unauthorized-response.interceptor';
import { ConfigService } from './shared/services/config';
import { MatDialogModule } from '@angular/material/dialog';

import { CreateCredentialsDialogComponent } from './admin/dialogs/create-credentials-dialog/create-credentials-dialog.component';
import { CreateAccessPolicyDialogComponent } from './admin/dialogs/create-access-policy-dialog/create-access-policy-dialog.component';
import { OpenTracingInterceptor } from './interceptors/open-tracing.interceptor';
import { ComponentsModule } from './shared/components/components.module';
import { MessageDialogComponent } from './admin/dialogs/message-dialog/message-dialog.component';
import { DirectivesModule } from './shared/directives/directives.module';
import { NomidioErrorPagesModule } from './shared/error-pages';
import { NomidioPageTitleModule } from './shared/page-title';
import { ProvidersModule } from './shared/providers/providers.module';
import { AppFormsModule } from './shared/forms/app-forms.module';

const configInitializerFactory = (config: ConfigService) => {
  return async () => await config.load();
};

@NgModule({ bootstrap: [
        AppComponent
    ],
    declarations: [
        AppComponent,
        CreateCredentialsDialogComponent,
        CreateAccessPolicyDialogComponent,
        MessageDialogComponent,
    ], imports: [AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        ComponentsModule,
        AppFormsModule,
        DirectivesModule,
        NomidioPageTitleModule,
        ProvidersModule,
        NomidioErrorPagesModule], providers: [
        { provide: APP_INITIALIZER, useFactory: configInitializerFactory, deps: [ConfigService], multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: OpenTracingInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedResponseInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
